import { useState, useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "";

// How long after fee payment the AI panel judges a dispute (see
// backend/src/lib/judgeTiming.js — JUDGE_DELAY_MINUTES overrides the 7-day
// default for dev/staging). Defaults to the production value ("7 days")
// while loading / on error so copy never shows a blank or broken value.
export function useJudgeTiming() {
  const [timing, setTiming] = useState({ days: 7, label: "7 days" });

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/ai/judge-timing-config`)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data?.label) setTiming({ days: data.days, label: data.label });
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return timing;
}
